<template>
  <div class="d-flex justify-content-center">
    <Alert
      :title="LABEL.ERRORI.OPS"
      :description="LABEL.ERRORI.NOT_FOUND"
      :btn="{
        label: LABEL.ERRORI.BACK_TO_REQUESTS,
        icon: 'arrow-left',
        action: () => this.$router.push({ name: nameRoutes.RICHIESTE }),
      }"
    />
  </div>
</template>

<script>
import { nameRoutes } from "../../libs/router/nameRoutes";
import LABEL from "../../libs/utils/label";
export default {
  data() {
    return {
      LABEL,
      nameRoutes,
    };
  },
};
</script>

<style lang="scss" scoped></style>
